// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1Qm_W","inner":"Form_inner__1P553","range":"Form_range__yM51a","name":"Form_name__bIimu","actions":"Form_actions__hO_TO"};